import QuestionAnswers from './QuestionAnswers';
import QuestionsOptions from './QuestionOptions';
import QuestionDescription from './QuestionDescription';

export const tabsOptions = (values, handleChange, setFieldValue, errors, questions, question, setSortableState) => {
  let tabs = [{
    eventKey: 'description',
    title: 'Descripción',
    content: <QuestionDescription errors={errors} handleChange={handleChange} values={values} />
  },{
    eventKey: 'options',
    title: 'Opciones',
    content: <QuestionsOptions values={values} handleChange={handleChange} setFieldValue={setFieldValue} errors={errors} questions={questions} />
  }];

  if (['Opción múltiple: solo una respuesta', 'Opción múltiple: se permiten varias respuestas', 'Matriz'].includes(values.questionType)) {
    tabs.push({
      eventKey: 'answers',
      title: 'Respuestas',
      content: <QuestionAnswers questionType={values.questionType} question={question} setSortableState={setSortableState} formValues={values} />
    });
    //Sort tabs, answers should be the first tab
    tabs = tabs.sort((a, b) => a.eventKey === 'answers' ? -1 : 1);
  }
  return tabs;
}